<template>
  <div class="animated fadeIn">

    <div class="modal fade show " id="lancarFinanceiroModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static" v-if="showModalDuracaoDesativarBateria">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tempo duração Desativar Bateria</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              
              <div class="col-md-12">
                <label>Duração</label><br>
                <select id="lancarFinanceiroTipoLancamento" type="text" class="form-control" v-model="duracaoDesativarBateria">
                  <option value="1">1 Dia</option>
                  <option value="3">3 Dias</option>
                  <option value="7">1 Semana</option>
                </select>
                <br>
                <smal>* após o período selecionado o evento será ativado automaticamente.</smal>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button id="confirmarLancarFinanceiro" type="button" class="btn btn-primary" v-on:click="confirmarAtivarAlertaBateria()">Confirmar</button>
            <button type="button" class="btn btn-danger" v-on:click="showModalDuracaoDesativarBateria = false">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando"> 
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>

      <div id="dados-formulario-tab" class="card">
        <div class="card-body">
          <div id="titulo">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                <h4>Editar Veículo</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 pull-right">
                <input id="botaoSalvar" class="btn btn-success" type="submit" value="Salvar" v-on:click="salvar">
                <router-link id="btnNovoVeiculo" class="btn btn-warning" to="/veiculos">
                  <span class="glyphicon glyphicon-back"></span> Fechar
                </router-link>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-sm-12 col-md-12">
              <div class="tabbable"> 
                <!-- Only required for left/right tabs -->
                <ul class="nav nav-tabs">
                  <li class="nav-item active"><a href="#tab1" data-toggle="tab" class="nav-link active">Geral</a></li>
                </ul>

                <div class="tab-content">
                  <div class="tab-pane active" id="tab1">
                    <div class="dados_form">
                      <div class="col-sm-12 col-md-12">
                        <input type="hidden" v-model="model.id" />
                        <div class="row">
                          <div class="form-group col-sm-2 col-md-2">
                            <label class="control-label">Placa:</label><br>
                            <input class="pula form-control placa" v-model="model.placa" readonly="readonly
                            " />
                          </div>
                          <div class="form-group col-sm-8 col-md-8">
                            <label class="control-label">Descrição:</label><br>
                            <input class="pula form-control" v-model="model.descricao"
                              required="required" />
                          </div>
                          
                          <div class="form-group col-sm-2 col-md-2">
                            <label>Data Cadastro:</label><br>
                            <template v-if="model.id === 0">
                              <input-data-picker class="pula data form-control" v-model="model.dataCadastroRastreamento" />
                            </template>
                            <template v-else>
                              <input-data-picker class="pula data form-control" v-model="model.dataCadastroRastreamento" readonly="readonly" />
                            </template>
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-sm-4 col-md-4">
                            <label class="control-label">Dados do Veículo:</label><br>
                            {{model.marca}}/<strong>{{model.modelo}}</strong> - {{model.anoFabricacao}}/{{model.anoModelo}}
                          </div>
                          <div class="form-group col-sm-2 col-md-2">
                            <label class="control-label">Km Atual:</label><br>
                            <input class="pula form-control" v-model="model.kmAtual" />
                          </div>   
                          <div class="form-group col-sm-4 col-md-4">
                            <label class="control-label">Senha Identificação:</label><br>
                            <input class="pula form-control " v-model="model.senhaIdentificacao" />
                          </div>
                          <div class="form-group col-sm-2 col-md-2">
                            <label class="control-label">Macro:</label><br>
                            <select class="pula form-control" v-model="model.macroAutomatica">
                              <option value="" label="" />
                              <option value="03" label="03 - Carga e Descarga" />
                              <option value="34" label="34 - Diaria" />
                            </select>
                          </div>
                        </div>

                        

                        <div class="card">
                          <div class="card-header">
                            Aplicativo
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div class="form-group col-sm-3 col-md-3">
                                <label>Alerta Roubo:</label><br>
                                <div v-if="model.alertaRoubo">
                                  <span class="text-danger"><strong>ATIVADO</strong></span>
                                  <br>
                                  <button class="btn btn-danger btn-block" v-on:click="ativarAlertaRoubo('Deseja realmente desativar o Alerta de Roubo desse Veículo?')">DESATIVAR</button>
                                </div>
                                <div v-else>
                                  <span class="text-success"><strong>DESATIVADO</strong></span>
                                  <br>
                                  <button class="btn btn-danger btn-block" v-on:click="ativarAlertaRoubo('<strong>Atenção</strong><br><br>Ao colocar o veículo em estado de alerta, todos os clientes poderão visualiza-lo. Não informe um falso alerta de roubo, passível de penalidades!<br><br><br><br><strong>Deseja realmente ativar o Alerta de Roubo desse Veículo</strong>?')">ATIVAR</button>
                                </div>
                              </div>
                              <template v-if="model.possuiBloqueioBau">
                                <div class="form-group col-sm-3 col-md-3">
                                  <label>Bloqueio Baú:</label><br>
                                  <div v-if="model.estaBloqueioBau">
                                    <span class="text-danger"><strong>BLOQUEADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" >DESBLOQUEAR</button>
                                  </div>
                                  <div v-else>
                                    <span class="text-success"><strong>DESBLOQUEADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block">BLOQUEAR</button>
                                  </div>
                                </div>
                              </template>
                              <template v-if="model.possuiBloqueioVeiculo">
                                <div class="form-group col-sm-3 col-md-3">
                                  <label>Bloqueio Veículo:</label><br>
                                  <div v-if="model.estaBloqueioVeiculo">
                                    <span class="text-danger"><strong>BLOQUEADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="bloquearVeiculo('Deseja realmente desbloquear esse Veículo?')">DESBLOQUEAR</button>
                                  </div>
                                  <div v-else>
                                    <span class="text-success"><strong>DESBLOQUEADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="bloquearVeiculo('Deseja realmente bloquear esse Veículo?')">BLOQUEAR</button>
                                  </div>
                                </div>
                              </template>

                              <template v-if="model.possuiEventoIgnicao">
                                <div class="form-group col-sm-3 col-md-3">
                                  <label>Alerta Ignição:</label><br>
                                  <div v-if="model.estaEventoIgnicao">
                                    <span class="text-danger"><strong>ATIVADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="ativarAlertaIgnicao('Deseja realmente desativar o Alerta de Ignição desse Veículo?')">DESATIVAR</button>
                                  </div>
                                  <div v-else>
                                    <span class="text-success"><strong>DESATIVADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="ativarAlertaIgnicao('Deseja realmente ativar o Alerta de Ignição desse Veículo?')">ATIVAR</button>
                                  </div>
                                </div>
                              </template>
                              <template v-if="model.possuiEventoArea">
                                <div class="form-group col-sm-3 col-md-3">
                                  <label>Alerta Área:</label><br>
                                  <div v-if="model.estaEventoArea">
                                    <span class="text-danger"><strong>ATIVADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="ativarAlertaArea('Deseja realmente desativar o Alerta de Área desse Veículo?')">DESATIVAR</button>
                                  </div>
                                  <div v-else>
                                    <span class="text-success"><strong>DESATIVADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="ativarAlertaArea('Deseja realmente ativar o Alerta de Área desse Veículo?')">ATIVAR</button>
                                  </div>
                                  <label class="control-label">Distância:</label><br>
                                  <input class="pula form-control " v-model="model.eventoAreaDistancia"  />
                                  <input class="pula form-control " type="hidden" v-model="model.eventoAreaLatitude" />
                                  <input class="pula form-control " type="hidden" v-model="model.eventoAreaLongitude" />
                                  
                                </div>
                              </template>
                              <template v-if="model.possuiEventoBateria">
                                <div class="form-group col-sm-3 col-md-3">
                                  <label>Alerta Bateria:</label><br>
                                  <div v-if="model.estaEventoBateria">
                                    <span class="text-danger"><strong>ATIVADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="ativarAlertaBateria('Deseja realmente desativar o Alerta de Bateria desse Veículo?')">DESATIVAR</button>
                                  </div>
                                  <div v-else>
                                    <span class="text-success"><strong>DESATIVADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="ativarAlertaBateria('Deseja realmente ativar o Alerta de Bateria desse Veículo?')">ATIVAR</button>
                                  </div>
                                </div>
                              </template>
                              <template v-if="model.possuiEventoVelocidade">
                                <div class="form-group col-sm-3 col-md-3">
                                  <label>Alerta Velocidade:</label><br>
                                  <div v-if="model.estaEventoVelocidade">
                                    <span class="text-danger"><strong>ATIVADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="ativarAlertaVelocidade('Deseja realmente desativar o Alerta de Velocidade desse Veículo?')">DESATIVAR</button>
                                  </div>
                                  <div v-else>
                                    <span class="text-success"><strong>DESATIVADO</strong></span>
                                    <br>
                                    <button class="btn btn-danger btn-block" v-on:click="ativarAlertaVelocidade('Deseja realmente ativar o Alerta de Velocidade desse Veículo?')">ATIVAR</button>
                                  </div>
                                  <br>
                                  <label class="control-label">Velocidade Máxima:</label><br>
                                  <input class="pula form-control " v-model="model.velocidadeMaxima" />
                                  
                                </div>
                              </template>
                              
                              
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      processando: false,
      model: {
        id: '0',
        ativo: false,
        ativoRastreamento: false,
        ativoMonitoramento: false,
        placa: '',
        descricao: '',
        dataCadastroRastreamento: '',
        clienteId: '0',
        clienteNomeFantasia: '',
        modelo: '',
        marca: '',
        anoFabricacao: '',
        anoModelo: '',
        veiculoTipoId: '0',
        veiculoCombustivelId: '0',
        renavam: '',
        chassi: '',
        kmAtual: '0',
        numeroEquipamento: '',
        marcaEquipamento: '',
        modeloEquipamento: '',
        operadoraChipEquipamento: '',
        dddChipEquipamento: '',
        numeroChipEquipamento: '',
        dataInstalacao: '',
        ativoObd: '',
        numeroObd: '',
        marcaObd: '',
        modeloObd: '',
        operadoraChipObd: '',
        dddChipObd: '',
        numeroChipObd: '',
        dataInstalacaoObd: '',
        ativoTeclado: '',
        tipoUsoTeclado: '',
        clientePagaId: '',
        clientePagaNomeFantasia: '',
        clienteRedirecionamento1Id: '',
        clienteRedirecionamento1NomeFantasia: '',
        clienteRedirecionamento2Id: '',
        clienteRedirecionamento2NomeFantasia: '',
        clienteRedirecionamento3Id: '',
        clienteRedirecionamento3NomeFantasia: '',
        senhaIdentificacao: '',
        observacaoInstalacao: '',
        observacaoGerais: '',
        analisarIgnicao: true,
        analisarTransmissso: true,
        analisarDAC: true,
        analisarEvento: true,
        emOperacao: true,
        intervaloMovimento: '0',
        limiteGPS: '0',
        limiteTempo: '0',
        limiteTransmissoesDiarias: '0',
        velocidadeMaxima: '0',
        limiteExcessoVelocidade: '0',
        tensaoBateriaMinima: '0',
        jornadaTrabalho: true,
        jornadaTrabalhoIgnicao: true,
        jornadaTrabalhoVelocidade: '',
        jornadaTrabalhoParadoAposPosicoes: '',
        macroAutomatica: '',
        tipoNegociacao: '',
        vendedorRastreamento: '',
        tipoPagamentoRastreamento: '',
        mesVencimentoAnualRastreamento: '',
        tipoVencimentoRastreamento: 'C',
        diaVencimentoRastreamento: '1',
        sascarId: '0',
        valorRepasse: '0',
        valorMensalidadeRastreamento: '0',
        extra24Horas: '0',
        extraSeguro: '0',
        extraWeb: '0',
        valorTotalMensalidadeRastreamento: '0',
        alertaRoubo: false,
        possuiBloqueioBau: false,
        possuiBloqueioVeiculo: false,
        possuiEventoArea: false,
        eventoAreaDistancia: '0',
        eventoAreaLatitude: '0',
        eventoAreaLongitude: '0',
        possuiEventoBateria: false,
        possuiEventoIgnicao: false,
        possuiEventoVelocidade: false,
        estaBloqueioBau: false,
        estaBloqueioVeiculo: false,
        estaEventoArea: false,
        estaEventoBateria: false,
        estaEventoIgnicao: false,
        estaEventoVelocidade: false
      },
      veiculosCombustiveis: [],
      veiculosTipos: [],
      vendedores: [],
      duracaoDesativarBateria: '1',
      showModalDuracaoDesativarBateria: false
    }
  },
  created: function () {
    this.buscar()
    // this.buscarVeiculosTipos()
    // this.buscarVeiculosCombustivel()
    this.buscarVendedores()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      self.processando = true
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/veiculos/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        var dados = response.data
        // self.model = response.data
        self.model.id = dados.id
        self.model.ativo = dados.ativo
        self.model.ativoRastreamento = dados.ativoRastreamento
        self.model.ativoMonitoramento = dados.ativoMonitoramento
        self.model.placa = dados.placa
        self.model.descricao = dados.descricao
        self.model.dataCadastroRastreamento = dados.dataCadastroRastreamento
        self.model.clienteId = dados.clienteId
        self.model.clienteNomeFantasia = dados.clienteNome
        self.model.modelo = dados.modelo
        self.model.marca = dados.marca
        self.model.anoFabricacao = dados.anoFabricacao
        self.model.anoModelo = dados.anoModelo
        self.model.veiculoTipoId = dados.veiculoTipoId
        self.model.veiculoCombustivelId = dados.veiculoCombustivelId
        self.model.renavam = dados.renavam
        self.model.chassi = dados.chassi
        self.model.kmAtual = dados.kmAtual
        self.model.numeroEquipamento = dados.numeroEquipamento
        self.model.marcaEquipamento = dados.marcaEquipamento
        self.model.modeloEquipamento = dados.modeloEquipamento
        self.model.operadoraChipEquipamento = dados.operadoraChipEquipamento
        self.model.dddChipEquipamento = dados.dddChipEquipamento
        self.model.numeroChipEquipamento = dados.numeroChipEquipamento
        self.model.dataInstalacao = dados.dataInstalacao
        self.model.ativoObd = dados.ativoObd
        self.model.numeroObd = dados.numeroObd
        self.model.marcaObd = dados.marcaObd
        self.model.modeloObd = dados.modeloObd
        self.model.operadoraChipObd = dados.operadoraChipObd
        self.model.dddChipObd = dados.dddChipObd
        self.model.numeroChipObd = dados.numeroChipObd
        self.model.dataInstalacaoObd = dados.dataInstalacaoObd
        self.model.ativoTeclado = dados.ativoTeclado
        self.model.tipoUsoTeclado = dados.tipoUsoTeclado
        self.model.clientePagaId = dados.clientePagaId
        self.model.clientePagaNomeFantasia = dados.clientePagaNome
        self.model.clienteRedirecionamento1Id = dados.clienteRedirecionamento1Id
        self.model.clienteRedirecionamento1NomeFantasia = dados.clienteRedirecionamento1Nome
        self.model.clienteRedirecionamento2Id = dados.clienteRedirecionamento2Id
        self.model.clienteRedirecionamento2NomeFantasia = dados.clienteRedirecionamento2Nome
        self.model.clienteRedirecionamento3Id = dados.clienteRedirecionamento3Id
        self.model.clienteRedirecionamento3NomeFantasia = dados.clienteRedirecionamento3Nome
        self.model.senhaIdentificacao = dados.senhaIdentificacao
        self.model.observacaoInstalacao = dados.observacaoInstalacao
        self.model.observacaoGerais = dados.observacaoGerais
        self.model.analisarIgnicao = dados.analisarIgnicao
        self.model.analisarTransmissso = dados.analisarTransmissso
        self.model.analisarDAC = dados.analisarDAC
        self.model.analisarEvento = dados.analisarEvento
        self.model.emOperacao = dados.emOperacao
        self.model.intervaloMovimento = dados.intervaloMovimento
        self.model.limiteGPS = dados.limiteGPS
        self.model.limiteTempo = dados.limiteTempo
        self.model.limiteTransmissoesDiarias = dados.limiteTransmissoesDiarias
        self.model.velocidadeMaxima = dados.velocidadeMaxima
        self.model.limiteExcessoVelocidade = dados.limiteExcessoVelocidade
        self.model.tensaoBateriaMinima = dados.tensaoBateriaMinima
        self.model.jornadaTrabalho = dados.jornadaTrabalho
        self.model.jornadaTrabalhoIgnicao = dados.jornadaTrabalhoIgnicao
        self.model.jornadaTrabalhoVelocidade = dados.jornadaTrabalhoVelocidade
        self.model.jornadaTrabalhoParadoAposPosicoes = dados.jornadaTrabalhoParadoAposPosicoes
        self.model.macroAutomatica = dados.macroAutomatica
        self.model.tipoNegociacao = dados.tipoNegociacao
        self.model.vendedorRastreamento = dados.vendedorRastreamento
        self.model.tipoPagamentoRastreamento = dados.tipoPagamentoRastreamento
        self.model.mesVencimentoAnualRastreamento = dados.mesVencimentoAnualRastreamento
        self.model.tipoVencimentoRastreamento = dados.tipoVencimentoRastreamento
        self.model.diaVencimentoRastreamento = dados.diaVencimentoRastreamento
        self.model.sascarId = dados.sascarId
        self.model.valorRepasse = dados.valorRepasse
        self.model.valorMensalidadeRastreamento = dados.valorMensalidadeRastreamento
        self.model.extra24Horas = dados.extra24Horas
        self.model.extraSeguro = dados.extraSeguro
        self.model.extraWeb = dados.extraWeb
        self.model.valorTotalMensalidadeRastreamento = dados.valorTotalMensalidadeRastreamento
        self.model.alertaRoubo = dados.alertaRoubo
        self.model.possuiBloqueioBau = dados.possuiBloqueioBau
        self.model.possuiBloqueioVeiculo = dados.possuiBloqueioVeiculo
        self.model.possuiEventoArea = dados.possuiEventoArea
        self.model.eventoAreaDistancia = dados.eventoAreaDistancia
        self.model.eventoAreaLatitude = dados.eventoAreaLatitude
        self.model.eventoAreaLongitude = dados.eventoAreaLongitude
        self.model.possuiEventoBateria = dados.possuiEventoBateria
        self.model.possuiEventoIgnicao = dados.possuiEventoIgnicao
        self.model.possuiEventoVelocidade = dados.possuiEventoVelocidade
        self.model.estaBloqueioBau = dados.estaBloqueioBau
        self.model.estaBloqueioVeiculo = dados.estaBloqueioVeiculo
        self.model.estaEventoArea = dados.estaEventoArea
        self.model.estaEventoBateria = dados.estaEventoBateria
        self.model.estaEventoIgnicao = dados.estaEventoIgnicao
        self.model.estaEventoVelocidade = dados.estaEventoVelocidade
        self.processando = false
      })
    },
    buscarVeiculosCombustivel: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarVeiculosCombustiveisAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.veiculosCombustiveis = dados
      })
    },
    buscarVeiculosTipos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarVeiculosTiposAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.veiculosTipos = dados
      })
    },
    buscarVendedores: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarVendedoresAtivos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.vendedores = dados
      })
    },
    setarCliente: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarCliente: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    setarClientePaga: function (cliente) {
      this.model.clientePagaId = cliente.id
      this.model.clientePagaNomeFantasia = cliente.nomeFantasia
      $(this.$el).find('#clientePagaNome').val(cliente.nomeFantasia)
    },
    verificarClientePaga: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clientePagaId = 0
        this.model.clientePagaNome = ''
        $(this.$el).find('#clientePagaId').val(0)
        $(this.$el).find('#clientePagaNome').val('')
      }
      if ($(this.$el).find('#clientePagaNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        $(this.$el).find('#clientePagaId').val(0)
        $(this.$el).find('#clientePagaNome').val('')
      }
    },
    setarClienteRedirecionamento1: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      this.model.descontoPercentual = cliente.descontoPadrao
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao
        this.setarFormaPagamento()
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarClienteRedirecionamento1: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    setarClienteRedirecionamento2: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      this.model.descontoPercentual = cliente.descontoPadrao
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao
        this.setarFormaPagamento()
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarClienteRedirecionamento2: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    setarClienteRedirecionamento3: function (cliente) {
      this.model.clienteId = cliente.id
      this.model.clienteNomeFantasia = cliente.nomeFantasia
      this.model.descontoPercentual = cliente.descontoPadrao
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao
        this.setarFormaPagamento()
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia)
    },
    verificarClienteRedirecionamento3: function () {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0
        this.model.clienteNome = ''
        this.model.descontoPercentual = 0
        $(this.$el).find('#clienteId').val(0)
        $(this.$el).find('#clienteNome').val('')
      }
    },
    bloquearVeiculo: function (message) {
      let self = this
      // let message = 'Deseja realmente bloquear esse Veículo?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/apimobile/comandoBloqueioVeiculo?veiculo=' + self.model.id
          axios.post(url, '', config)
          .then(function (response) {
            console.log(response)
            self.buscar()
            dialog.close()
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    ativarAlertaRoubo: function (message) {
      let self = this
      // let message = 'Deseja realmente bloquear esse Veículo?'
      let options = {
        html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/apimobile/eventoRoubo?veiculo=' + self.model.id
          axios.post(url, '', config)
          .then(function (response) {
            console.log(response)
            self.buscar()
            dialog.close()
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    ativarAlertaIgnicao: function (message) {
      let self = this
      // let message = 'Deseja realmente bloquear esse Veículo?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/apimobile/eventoIgnicao?veiculo=' + self.model.id
          axios.post(url, '', config)
          .then(function (response) {
            console.log(response)
            self.buscar()
            dialog.close()
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    ativarAlertaArea: function (message) {
      let self = this
      // let message = 'Deseja realmente bloquear esse Veículo?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/apimobile/eventoArea?veiculo=' + self.model.id + '&distancia=' + self.model.eventoAreaDistancia + '&latitude=' + self.model.eventoAreaLatitude + '&longitude=' + self.model.eventoAreaLongitude
          axios.post(url, '', config)
          .then(function (response) {
            console.log(response)
            self.buscar()
            dialog.close()
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    modificarLocalArea: function () {
      let self = this
      let marker = {}
      marker = {
        lat: parseFloat(self.model.eventoAreaLatitude),
        lng: parseFloat(self.model.eventoAreaLongitude)
      }
      self.markers.push({ position: marker })
      this.mostrarModalArea = true
      // self.removerMarkers()
      const bounds = new window.google.maps.LatLngBounds()
      // self.path.push({
      //   lat: self.selecionados[i].latitude,
      //   lng: self.selecionados[i].longitude
      // })
      // self.markers.push({ position: marker, descricao: self.dadosGrid[i].placaVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
      console.log('LAT: ' + marker.lat)
      console.log('LONG: ' + marker.lng)
      let myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
      bounds.extend(myLatLng)
    },
    ativarAlertaBateria: function (message) {
      let self = this
      if (self.model.estaEventoBateria) {
        self.showModalDuracaoDesativarBateria = true
      } else {
        let options = {
          html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
          loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
          reverse: false, // switch the button positions (left to right, and vise versa)
          okText: 'SIM',
          cancelText: 'NÃO',
          animation: 'zoom', // Available: "zoom", "bounce", "fade"
          type: 'basic', // coming soon: 'soft', 'hard'
          verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
          clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        }
        this.$dialog.confirm(message, options)
        .then((dialog) => {
          //
          self.confirmarAtivarAlertaBateria()
          dialog.close()
        })
      }
    },
    confirmarAtivarAlertaBateria: function (message) {
      let self = this
      self.showModalDuracaoDesativarBateria = false
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.loading = true
      var url = '/apimobile/eventoBateria?veiculo=' + self.model.id + '&duracao=' + self.duracaoDesativarBateria
      axios.post(url, '', config)
      .then(function (response) {
        console.log(response)
        self.buscar()
      })
    },
    ativarAlertaVelocidade: function (message) {
      let self = this
      // let message = 'Deseja realmente bloquear esse Veículo?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard'
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
      }
      this.$dialog.confirm(message, options)
      .then((dialog) => {
        setTimeout(() => {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          self.loading = true
          var url = '/apimobile/eventoVelocidade?veiculo=' + self.model.id + '&velocidade=' + self.model.velocidadeMaxima
          axios.post(url, '', config)
          .then(function (response) {
            console.log(response)
            self.buscar()
            dialog.close()
          })
        }, 2500)
      })
      .catch(function () {
        console.log('Clicked on cancel')
      })
    },
    salvar: function () {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(JSON.stringify(self.model))
          self.processando = true
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          var url = '/api/veiculos/salvar'
          axios.post(url, JSON.stringify(self.model), config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.processando = false
              self.$toastr('success', 'Veículo gravado com sucesso.', 'Atenção')
              self.$router.replace('/veiculos')
            }
          })
          .catch(function (error) {
            self.processando = false
            console.log(error)
          })
        } else {
          this.$toastr('error', 'Complete os campos destacados.', 'Atenção')
        }
      })
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/views/veiculos/VeiculosEditar.vue